/* Format "26-02-2012" */
export const stringToTimestamp = (dateString: string) => Date.parse(dateString.split("-").reverse().join("-"));
